import logoImaaagery from "../../Assets/Imaaagery.png"

export const logoImAAAgery = logoImaaagery
export const widthLogo = 200
export const altLogo = "Logo Imaaagery"